import React from "react";

const TaxFormTopInputs = ({ name, description, status, onChange }) => {
    return (
        <>
            <p className="flex items-center py-4">
                <label
                    className="text-ec-body font-inter font-medium text-base leading-4 w-[180px]"
                    htmlFor="easycommerce-tax-name"
                >
                    Name
                </label>
                <div className="w-full">
                    <div className="flex">
                        <input
                            id="easycommerce-tax-name"
                            type="text"
                            className="easycommerce-tax-input w-full focus:outline-none focus:shadow-none"
                            placeholder="Tax class name"
                            value={name}
                            onChange={(e) => onChange("name", e.target.value)}
                        />
                    </div>
                </div>
            </p>
            <p className="flex items-center py-4">
                <label
                    className="text-ec-body font-inter font-medium text-base leading-4 w-[180px]"
                    htmlFor="easycommerce-tax-description"
                >
                    Description
                </label>
                <div className="w-full">
                    <div className="flex">
                        <input
                            id="easycommerce-tax-description"
                            type="text"
                            className="easycommerce-tax-input w-full focus:outline-none focus:shadow-none"
                            placeholder="Write description here"
                            value={description}
                            onChange={(e) =>
                                onChange("description", e.target.value)
                            }
                        />
                    </div>
                </div>
            </p>
            <p className="flex items-center py-4">
                <label
                    className="text-ec-body font-inter font-medium text-base leading-4 w-[180px]"
                    htmlFor="easycommerce-tax-status"
                >
                    Enable/Disable
                </label>
                <div className="w-full">
                    <div className="flex">
                        <label className="easycommerce-switch">
                            <input
                                id="easycommerce-tax-status"
                                type="checkbox"
                                checked={status}
                                onChange={(e) =>
                                    onChange("status", e.target.checked)
                                }
                            />
                            <span className="easycommerce-slider easycommerce-round"></span>
                        </label>
                    </div>
                </div>
            </p>
        </>
    );
};

export default TaxFormTopInputs;
